<input class="col-lg-6" #someInput id="typeahead-http" [(ngModel)]="userSearch" type="search" [ngbTypeahead]="search"
  (selectItem)="selectOperateur($event)" (focus)="focus$.next($event.target.value)"
  placeholder="{{'page.common.recherche-operateur.placeholder' | translate}}" [editable]="false"
  [resultFormatter]="formatter" [inputFormatter]="formatter" class="form-control" />

<div class="mt-1">
  <span *ngIf="searching" translate>label.chargement</span>
  <span *ngIf="noResult" translate>label.aucunResultat</span>
</div>
